import { jsx as _jsx } from "react/jsx-runtime";
import { GroupPfvTabs } from "./GroupPfvTabs";
import { createRoot } from "react-dom/client";
import { Assertions } from "../../RcsbUtils/Helpers/Assertions";
var assertDefined = Assertions.assertDefined;
export class RcsbFvGroupTabsBuilder {
    static buildGroupTabs(elementId, groupProvenanceId, groupId, query, additionalConfig) {
        const element = document.getElementById(elementId);
        assertDefined(element);
        createRoot(element).render(_jsx(GroupPfvTabs, { groupProvenanceId: groupProvenanceId, groupId: groupId, searchQuery: query, additionalConfig: additionalConfig }));
    }
}
//# sourceMappingURL=RcsbFvGroupTabsBuilder.js.map